import React from 'react';
import {Col, Row} from 'reactstrap'
import ListIcon from '../../assets/images/icons/list.svg'
import StarIcon from '../../assets/images/icons/star.svg'
import LocationIcon from '../../assets/images/icons/location.svg'
import DocumentIcon from '../../assets/images/icons/document.svg'
import GraphIcon from '../../assets/images/icons/graph.svg'
import MegaphoneIcon from '../../assets/images/icons/megaphone.svg'
import TicketIcon from '../../assets/images/icons/ticket.svg'
import SocialIcon from '../../assets/images/icons/social.svg'

const FreeFeaturesSummary = (props) => {
  const { featuringPublisher, publisherName, features } = props;
  return (
    <div className="features-summary">
      <div className="title">
        Free Features
      </div>
      <Row className="no-gutters">
        <Col lg="12">
          <ul className="text-left">
            {featuringPublisher && <li><img className="svgIcon" src={ListIcon}/> An event listing on {publisherName}.</li>}
            <li><img className="svgIcon" src={SocialIcon}/> Unlimited social reposting.</li>
            <li><img className="svgIcon" src={TicketIcon}/> Ticketing - Use ours, or add your own.</li>
            <li><img className="svgIcon" src={GraphIcon}/> Basic event progress report.</li>
            <li><img className="svgIcon" src={MegaphoneIcon}/> Promotion lasts until your event ends.</li>
          </ul>
        </Col>
      </Row>
    </div>
  );
};

export default FreeFeaturesSummary;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/FreeFeaturesSummary.jsx